export const STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];

export const SITE_TYPES = [
  { key: "in_home", label: "In-home" },
  { key: "community", label: "Community settings" },
  { key: "provider_office", label: "Provider-owned office" },
  { key: "provider_centre", label: "Provider-owned centre / hub" },
  { key: "provider_residential", label: "Provider-owned residential (SIL/SDA)" },
  { key: "telehealth", label: "Telehealth / online" },
];

export const ENTITY_TYPES = [
  { value: "pty_ltd", label: "Pty Ltd" },
  { value: "sole_trader", label: "Sole trader" },
  { value: "trust", label: "Trust" },
  { value: "partnership", label: "Partnership" },
  { value: "nfp", label: "Not-for-profit" },
];

export const WORKFORCE_MODELS = [
  { value: "sole_trader", label: "Sole trader only" },
  { value: "employ", label: "Employ workers" },
  { value: "subcontractors", label: "Subcontractors" },
  { value: "labour_hire", label: "Labour-hire" },
  { value: "mix", label: "Mix" },
];

export const HIGH_INTENSITY_SUPPORTS = [
  { key: "bowel_care", label: "Complex bowel care" },
  { key: "enteral_feeding", label: "Enteral feeding PEG / NG" },
  { key: "severe_dysphagia", label: "Severe dysphagia management" },
  { key: "tracheostomy", label: "Tracheostomy care" },
  { key: "urinary_catheter", label: "Urinary catheter care" },
  { key: "ventilator", label: "Ventilator support" },
  { key: "sc_injections", label: "Subcutaneous injections" },
  { key: "complex_wound", label: "Complex wound care" },
  { key: "pressure_care", label: "Pressure care" },
  { key: "stoma_care", label: "Stoma care" },
  { key: "mealtime_choking", label: "Mealtime management (high choking risk)" },
  { key: "epilepsy", label: "Epilepsy / emergency medication" },
];

export const COHORTS = [
  { key: "under_9", label: "Participants under 9 years old", meta: "→ Module 3 (M3)" },
  { key: "under_18", label: "Participants under 18 (any age)", meta: "→ WWCC required" },
  { key: "cald", label: "CALD participants", meta: "cultural safety policy" },
  { key: "atsi", label: "Aboriginal / Torres Strait Islander", meta: "cultural safety framework" },
  { key: "rural", label: "Regional / rural / remote areas" },
  { key: "aac", label: "Complex communication needs (AAC)" },
  { key: "custodial", label: "Custodial / forensic settings", meta: "additional protocols" },
];

export const TIMELINE_DRIVERS = [
  { value: "participant_waiting", label: "Specific participant / contract waiting" },
  { value: "mandatory_rules", label: "New mandatory registration rules" },
  { value: "lapsing", label: "Existing registration lapsing" },
  { value: "investor", label: "Investor / funder requirement" },
  { value: "strategic", label: "Strategic, no deadline" },
];
